import { useEffect, useState } from "react";
import { axiosReq } from "../api/axiosDefaults";

const useFetchAllListings = () => {
    const [listings, setListings] = useState({ results: [] });
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        // Memory leak prevention
        let isMounted = true;
        const abortController = new AbortController();

        const fetchListings = async () => {
            try {
                setHasLoaded(false);
                let allListings = [];
                let nextUrl = '/listings/?page_size=100';
                let pageCount = 0;
                const maxPages = 20;

                while (nextUrl && pageCount < maxPages) {
                    const { data } = await axiosReq.get(nextUrl, {
                        signal: abortController.signal // ✅ Allow cancellation
                    });

                    // Check if component still mounted
                    if (!isMounted) break;

                    if (data.results && Array.isArray(data.results)) {
                        allListings = [...allListings, ...data.results];
                    } else if (Array.isArray(data)) {
                        allListings = [...allListings, ...data];
                        break;
                    }

                    nextUrl = data.next;

                    if (nextUrl && (nextUrl.startsWith('http://') || nextUrl.startsWith('https://'))) {
                        const url = new URL(nextUrl);
                        const baseURL = axiosReq.defaults?.baseURL || '';

                        if (baseURL && url.pathname.startsWith(baseURL)) {
                            nextUrl = url.pathname.substring(baseURL.length) + url.search;
                        } else {
                            nextUrl = url.pathname + url.search;
                        }
                    }

                    pageCount++;
                }

                // Only set state if component is still mounted
                if (isMounted) {
                    setListings({ results: allListings });
                    setHasLoaded(true);
                }
            } catch (err) {
                if (isMounted && err.name !== 'AbortError' && err.name !== 'CanceledError') {
                    console.error('Error fetching listings:', err);
                    setHasLoaded(true);
                }
            }
        };

        fetchListings();

        // Cleanup function
        return () => {
            isMounted = false;
            abortController.abort();
        };
    }, []);

    return { listings, setListings, hasLoaded };
};

export default useFetchAllListings;